export default __webpack_public_path__ + "static/media/DisplayExample.67486eb5.png";